export default __webpack_public_path__ + "static/media/RakshabandanNew1.c26a20f5.png";